import { useMemo } from 'react'

import { useRouterStore } from '../../Store/hooks/useStore'
import { transformSiderMenus } from '../utils/transformSiderMenus'

export const useVisibleMenus = () => {
  const visibleResources = useRouterStore(state => state.visibleResources)

  return useMemo(() => {
    return transformSiderMenus(visibleResources)
  }, [visibleResources])
}
